import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICategoryCharity, ICategoryCharityDetails} from "../../models/category_charity/response";
import {ICategoryCharityQuery} from "../../models/category_charity/query";
import {DEFAULT_FUNCTION, DEFAULT_QUERY} from "../../utils/helpers/constants";
import {ICreateCategoryCharity, IUpdateCategoryCharity} from "../../models/category_charity/request";
import {createContext} from "react";


export type CategoryCharityLoading =
    | "list"
    | "details"
    | "create"
    | "update"
    | "delete";

export interface IInternalState {
  loading: CategoryCharityLoading[];

  list?: IBaseListingResponse<ICategoryCharity>;
  query: ICategoryCharityQuery;

  details?: ICategoryCharityDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};


export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: ICategoryCharityDetails) => void;

    createCategoryCharity: (request: ICreateCategoryCharity) => void;
    updateCategoryCharity: (id: number, request: IUpdateCategoryCharity) => void;
    deleteCategoryCharity: (id: number) => void;

    setSearch: (search?: string) => void;
    setQuery: (query: ICategoryCharityQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,

    createCategoryCharity: DEFAULT_FUNCTION,
    updateCategoryCharity: DEFAULT_FUNCTION,
    deleteCategoryCharity: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,

  },
};

const CategoryCharityContext = createContext(externalState);

export default CategoryCharityContext;